import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const SimpleTableStyled = styled.table`
  & th {
    text-align: left;
    color: ${(props) => props.theme.atlas.semantic.color.type.default};
    padding: 10px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
    font-weight: 600;
  }

  & td {
    color: ${(props) => props.theme.atlas.semantic.color.type.muted};
    padding: 10px;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  }

  & tr td {
    &:last-child,
    &:nth-last-child(2) {
      color: ${(props) => props.theme.atlas.semantic.color.type.default};
    }
  }
`;
